import React from 'react';
import PropTypes from 'prop-types';
import CheckboxButton from 'components/buttons/CheckboxButton';

const ModalItem = ({ item, title, index, onChecked }) => {
  const handleChecked = e => {
    onChecked({ ...item, isActive: e.value }, index);
  };

  return (
    <CheckboxButton
      checked={item.isActive}
      title={title}
      onChange={handleChecked}
      hasTransparentBg
    />
  );
};

ModalItem.propTypes = {
  item: PropTypes.shape({
    isActive: PropTypes.bool.isRequired
  }).isRequired,
  title: PropTypes.string.isRequired,
  index: PropTypes.number.isRequired,
  onChecked: PropTypes.func.isRequired
};

export default ModalItem;
